export default __webpack_public_path__ + "static/media/heroFood1.58d8cc51.svg";